import PropTypes from 'prop-types';

function HamburgerButton({ isOpen, onToggle }) {
  return (
    <div
      id="btn-ham"
      className="hidden max-[650px]:block w-5 h-5 cursor-pointer relative"
      onClick={onToggle}
    >
      <div className="relative w-full h-full">
        <span className={`absolute top-[10%] right-0 w-full h-[12%] bg-white transition-all duration-500 ${isOpen ? 'w-0' : ''}`}></span>
        <span className={`absolute top-1/2 -translate-y-1/2 w-full h-[12%] bg-white transition-all duration-500 ${isOpen ? 'rotate-[135deg]' : ''}`}></span>
        <span className={`absolute top-1/2 -translate-y-1/2 w-full h-[12%] bg-white transition-all duration-500 ${isOpen ? 'rotate-45' : ''}`}></span>
        <span className={`absolute bottom-[10%] left-0 w-full h-[12%] bg-white transition-all duration-500 ${isOpen ? 'w-0' : ''}`}></span>
      </div>
    </div>
  );
}

HamburgerButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default HamburgerButton;
